module.exports = require('./helpers/bundle-url').getBundleURL('dwYZa') + "wolverine.6acf5939.png";